import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/lawFile`
//#region 基本信息
const GetStatusList = `${apiUrl}/statusList`
const GetList = `${apiUrl}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Read = (id: number) => `${apiUrl}/read/${id}`
const Download = (id: number) => `${apiUrl}/download/${id}`
//#endregion

export const emptyLawFile: LawFileData = {
    Id: 0,
    ClassifyId: 0,
    LawFileTitle: '',
    LawFileCode: '',
    LawBrief: '',
    PublishDepartment: '',
    PublishDate: new Date(),
    AvailableDate: null,
    LawContent: '',
    Comments: '',
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    ClassifyName: '',
    NewUserName: '',
    UpdateUserName: '',

    StatusText: '',
    AttachPath: '',
    AttachType: 0,
    AttachGuid: '',
    ActionList: []
}
export interface LawFileData {
    [key: string]: any
    Id: number
    ClassifyId: number
    LawFileTitle: string
    LawFileCode: string
    LawBrief: string
    PublishDepartment: string
    PublishDate: Date
    AvailableDate: Date | null
    LawContent: string
    Comments: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    ClassifyName: string
    NewUserName: string
    UpdateUserName: string

    StatusText: string
    AttachPath: string
    AttachType: number
    AttachGuid: string
    ActionList: any[]
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const read = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Read(id)
    })
}
export const download = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Download(id)
    })
}

export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
